import { Model } from "services/models/model";
import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { ApprovalScopeItemActionDocumentMockupModel } from "./approval-scope-item-action-document-mockup.model";
import { IntegrationLinkTypeEnum } from "services/enums/integrationLinkType.enum";

export class ApprovalScopeItemActionModel extends Model implements IModel<ApprovalScopeItemActionModel> {
  approvalScopeItemId: string = "";
  approvalActionId: string = "";
  sequence: number = 0;
  integrationLinkTypes: number[] = [];
  documentMockupMappings: ApprovalScopeItemActionDocumentMockupModel[] = [];
  documentGenerationApprovalScopeItemId: string = "";

  static normalizeIntegrationLinkTypes(
    values: Array<string | number> | null | undefined
  ): number[] {
    return IntegrationLinkTypeEnum.toIds(values);
  }

  static create(input: any): ApprovalScopeItemActionModel {
    const model = ObjectMapper.deserialize<ApprovalScopeItemActionModel>(
      ApprovalScopeItemActionModel,
      input
    );

    model.integrationLinkTypes = ApprovalScopeItemActionModel.normalizeIntegrationLinkTypes(
      input.integrationLinkTypes
    );
    model.documentMockupMappings = (input.documentMockupMappings ?? []).map((mapping: any) =>
      ApprovalScopeItemActionDocumentMockupModel.create(mapping)
    );

    return model;
  }
}
